module.exports = __webpack_public_path__ + "img/documentos_digitais_bg.37b8b7c0.webp";